<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/shipCompany' }">运输公司</el-breadcrumb-item>
        <el-breadcrumb-item>运输公司详情信息</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 卡片 -->
        <el-card class="box-card">
            <el-descriptions direction="vertical" :column="6" border>
                <el-descriptions-item label="公司名称">{{ baseInfo.name }}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{ baseInfo.mobile }}</el-descriptions-item>
                <el-descriptions-item label="法人">{{ baseInfo.corporation }}</el-descriptions-item>
                <el-descriptions-item label="性别">{{ baseInfo.sex }}</el-descriptions-item>
                <el-descriptions-item label="类型">{{ baseInfo.type }}</el-descriptions-item>
                <el-descriptions-item label="信用代码证">{{ baseInfo.credit_code }}</el-descriptions-item>
                <el-descriptions-item label="银行">{{ baseInfo.bank }}</el-descriptions-item>
                <el-descriptions-item label="银行卡号">{{ baseInfo.bank_account }}</el-descriptions-item>
                <el-descriptions-item label="生日">{{ baseInfo.birthday }}</el-descriptions-item>
                <el-descriptions-item label="证书编号">{{ baseInfo.certificate_no }}</el-descriptions-item>
                <el-descriptions-item label="发证日期">{{ baseInfo.issue_date }}</el-descriptions-item>
                <el-descriptions-item label="注册日期">{{ baseInfo.birthday }}</el-descriptions-item>
                <el-descriptions-item label="成立日期">{{ baseInfo.incorporation_date }}</el-descriptions-item>
                <el-descriptions-item label="注册资本">{{ baseInfo.registered_capital }}</el-descriptions-item>
                <el-descriptions-item label="归属地">{{ baseInfo.nation }}</el-descriptions-item>
                <el-descriptions-item label="组织形式">{{ baseInfo.issue_organization }}</el-descriptions-item>
                <el-descriptions-item label="地址">{{ baseInfo.address }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{ baseInfo.remark }}</el-descriptions-item>
                <el-descriptions-item label="业务范围">{{ baseInfo.business_scope }}</el-descriptions-item>
            </el-descriptions>
        </el-card>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                baseInfo: []
            }
        },
        created() {
            this.id = this.$route.query.id;
            //console.log(this.id,99);
            this.listDetails()
        },
        methods:{
            listDetails(){
                let param = {
                    id: this.id,
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                }
                this.$axios.shipCompanyDetails(param).then(res => {
                    if(res.code == 200){
                        this.baseInfo = res.data
                    }else if(res.code == 0){
                        this.$toast.fail(res.msg)
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error =>{
                    //console.log(error);
                })
            },
        }
    }

</script>
<style scoped lang="less">
    .box-card{
        width: 100%;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/view/shipCompany/details.vue